'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleLayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleLayer = exports.SimpleLayer = (_temp = _class = function (_React$PureComponent) {
  _inherits(SimpleLayer, _React$PureComponent);

  function SimpleLayer() {
    _classCallCheck(this, SimpleLayer);

    return _possibleConstructorReturn(this, (SimpleLayer.__proto__ || Object.getPrototypeOf(SimpleLayer)).apply(this, arguments));
  }

  _createClass(SimpleLayer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          components = _props.components,
          LayerItem = _props.LayerItem,
          LayerGrid = _props.LayerGrid,
          style = _props.style;

      return _react2.default.createElement(
        LayerGrid,
        { className: 'o-layer o-layer-simple', style: style },
        components.map(function (item, index) {
          return _react2.default.createElement(
            LayerItem,
            _extends({ key: item.key || index }, item.attrs, { className: 'o-layer-elem_box' }),
            item && item.component ? _react2.default.createElement(item.component, null) : null
          );
        })
      );
    }
  }]);

  return SimpleLayer;
}(_react2.default.PureComponent), _class.propTypes = {
  components: _propTypes2.default.array,
  LayerItem: _propTypes2.default.any,
  LayerGrid: _propTypes2.default.any,
  style: _propTypes2.default.object
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/layers/simpleLayer/index.jsx
// module id = 123
// module chunks = 0